var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n\t"+_vm._s(_vm.test)+"\n\n"),_c('line-component',{attrs:{"height":_vm.height,"chart-data":_vm.data,"chart-options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }